export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 1;
export const RES_PER_PAGE = 10;
export const KEY = 'a2732ef9-16ce-40ff-b41e-460ee721a5c2';
export const MODAL_ClOSE_SEC = 2.5;

// a2732ef9-16ce-40ff-b41e-460ee721a5c2
